import { useTranslation } from "react-i18next";

import { cn } from "@/utils/cn";

const NoData = ({ message, children }: { message?: string; children?: React.ReactNode }) => {
  const { t } = useTranslation();
  return (
    <div className=" flex h-[24rem] w-full flex-col items-center justify-center">
      <img className="mb-[1.5rem] w-[12.5rem]" src="/images/no-data.png" />
      <span className={cn("max-w-[29.375rem] text-center text-[2rem] font-semibold", { "mb-4": children })}>
        {message ?? t("NoData.title")}
      </span>
      {children}
    </div>
  );
};

export default NoData;
